
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/translate-video-from-spanish-to-japanese",
      function () {
        return require("private-next-pages/translate-video-from-spanish-to-japanese.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/translate-video-from-spanish-to-japanese"])
      });
    }
  